import React from "react";
import { Scale, Clock, Sparkles } from "lucide-react";

export const WEIGHT_COLOR = {
  Perfect: "#FFE600",
  Heavy: "#00F0FF",
  Balanced: "#7A5CFF",
  Light: "#52525B",
};

const Map = ({ map, label }) => (
  <div className="min-w-0">
    <div className="font-mono-sig text-[9px] tracking-[0.25em] uppercase text-[#52525B] mb-1">{label}</div>
    <div className="font-constitution text-sm sm:text-base flex flex-wrap gap-x-2 gap-y-1">
      {((map || "").match(/.{1,4}/g) || []).map((group, gi) => (
        <span key={gi} className="inline-flex">
          {group.split("").map((ch, i) => (
            <span key={i} className={ch === "1" ? "deviation-glow" : "static-dot opacity-60"}>
              {ch}
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);

export const CardConstitution = ({ card }) => {
  const w = card?.weight;
  if (!w) return null;
  const color = WEIGHT_COLOR[w.class] || WEIGHT_COLOR.Light;
  const toughness = Math.round((card.held_days || 0) * (w.score / 100) * 10) / 10;
  return (
    <div data-testid="card-constitution" className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <Scale className="w-4 h-4" style={{ color }} />
          <span className="font-mono-sig text-[10px] tracking-[0.3em] uppercase text-[#A0A0AB]">Constitution · heaviness</span>
        </div>
        <div className="text-right">
          <span data-testid="card-weight-score" className="font-display font-black text-2xl" style={{ color }}>{w.score}</span>
          <span className="font-mono-sig text-[10px] uppercase tracking-[0.2em] ml-2" style={{ color }}>{w.class}</span>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 rounded-xl bg-black/30 border border-white/5 p-4">
        <Map map={w.static_map} label={`Static · ${w.static_deviations} dev`} />
        <Map map={w.moving_map} label={`Moving · ${w.moving_deviations} dev`} />
      </div>
      <div className="flex items-center gap-5 mt-3 font-mono-sig text-[11px] text-[#A0A0AB]">
        <span className="inline-flex items-center gap-1.5"><Sparkles className="w-3.5 h-3.5 text-[#FFE600]" /> {w.total_deviations} deviations</span>
        <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#00F0FF]" /> held {card.held_days ?? 0}d</span>
        <span className="inline-flex items-center gap-1.5">toughness <b style={{ color }}>{toughness}</b></span>
      </div>
    </div>
  );
};
